import {useRouteLoaderData} from '@remix-run/react'
import React from 'react'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'
import {useScrollToTop} from '~/hooks/use-scroll-to-top'
import {IconChevronRightThick} from '~/icons/brg-icon-chevron-right-thick'

const ScrollOnTop = () => {
  const {visible, scrollToTop} = useScrollToTop(1500)
  const {language} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)

  return visible ? (
    <div className="fixed bottom-10 right-8 z-40 flex flex-col items-center justify-center text-sm">
      <button
        className="flex size-10 items-center justify-center rounded-full bg-black"
        type="button"
        aria-label="scroll to top"
        onClick={() => scrollToTop()}
      >
        <IconChevronRightThick className="size-4 -rotate-90 fill-white" />
      </button>
      {translations.BackToTop}
    </div>
  ) : null
}

export default ScrollOnTop
